<template>
  <div :id="id" class="v-input v-text-field theme--light primary--text">
    <div class="v-input__control">
      <div class="v-input__slot">
        <div class="v-text-field__slot">
          <label aria-hidden="true" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
            {{ label }}
          </label>
          <input
              v-model="model"
              @input="input"
              @focus="focus"
              @blur="blur"
              aria-label="Price($)"
              name="price"
              type="text"
              :inputmode="inputMod"
          >
        </div>
      </div>
      <div class="v-text-field__details">
        <div class="v-messages theme--light">
          <div class="v-messages__wrapper">
            {{ errorMsg }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VNumberField',
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      type: String,
      default: '',
    },
    emptyMod: {
      type: Boolean,
      required: false,
      default: false,
    },
    floatMod: {
      type: Boolean,
      required: false,
      default: false,
    },
    inputMod:{
      required: false,
      type: String,
      default: 'numeric',
    },
    RegExpRule: {
      type: RegExp,
      required: false,
      default: () => /^[1-9]+[0-9]*$/,
    },
    value: {},
  },
  data() {
    return {
      model: null,
      showItems: false,
      item: {},
      labelItem: {},
      messages: {},
      errorMsg: '',
    }
  },
  mounted() {
    this.item = document.getElementById(this.id);

    if (this.item) {
      this.labelItem = this.item.querySelector('.v-label');
      this.messages = this.item.querySelector('.v-messages');
    }
    if (this.value) {
      this.model = this.value;

      if (this.labelItem) {
        if (!this.labelItem.classList.contains('v-label--active')) {
          this.labelItem.classList.add('v-label--active');
        }
      }
    }
  },
  watch: {
    value() {
      this.model = this.value;
    }
  },
  methods: {
    input() {
      if (this.floatMod) {
        this.model = this.floatValidate(this.model);
      } else {
        this.model = this.intValidate(this.model);
      }

      if (this.model !== null && this.model !== '') {
        if (this.labelItem && !this.labelItem.classList.contains('v-label--active')) {
          this.labelItem.classList.add('v-label--active');
        }
        this.validate();
      } else if (this.labelItem) {
          this.labelItem.classList.remove('v-label--active');
      }

      this.$emit('input', this.model);
    },
    blur() {
      if (this.item) {
        this.item.classList.remove('v-input--is-focused');

        if (this.labelItem) {
          if (this.model === null || this.model === '') {
            this.labelItem.classList.remove('v-label--active');
          }
          this.labelItem.classList.remove('primary--text');
        }
      }
      this.validate();
    },
    focus() {
      if (this.item) {
        this.item.classList.add('v-input--is-focused');

        if (this.labelItem) {
          if (!this.labelItem.classList.contains('v-label--active')) {
            this.labelItem.classList.add('v-label--active');
          }
          this.labelItem.classList.add('primary--text');
        }
      }
    },
    validate() {
      let isValid = true;

      if (!this.emptyMod && (this.model === null || this.model === '')) {
        isValid = false;
        this.errorMsg = 'Field is required';
      } else if (!this.RegExpRule.test(this.model)) {
        isValid = false;
        this.errorMsg = 'Field must be valid';
      } else {
        this.errorMsg =  '';
        this.removeErrClass();
      }
      this.$emit('validate', isValid);

      if (!isValid) {
        this.setErrClass();
      }

      return isValid;
    },
    intValidate(val) {
      return val.replace(/\D/g, '');
    },
    floatValidate(val) {
      const numericPart = val.replace(/[^\d.]/g, '');
      const parts = numericPart.split('.');

      return parts.length > 1 ? parts[0] + '.' + parts.slice(1).join('') : parts[0];
    },
    setErrClass() {
      if (this.item) {
        if (!this.item.classList.contains('error--text')) {
          this.item.classList.add('error--text');
        }
        if (!this.item.classList.contains('v-input--has-state')) {
          this.item.classList.add('v-input--has-state');
        }
        if (!this.labelItem.classList.contains('error--text')) {
          this.labelItem.classList.add('error--text');
        }
        if (!this.messages.classList.contains('error--text')) {
          this.messages.classList.add('error--text');
        }
      }
    },
    removeErrClass() {
      if (this.item) {
        if (this.item.classList.contains('error--text')) {
          this.item.classList.remove('error--text');
        }
        if (this.item.classList.contains('v-input--has-state')) {
          this.item.classList.remove('v-input--has-state');
        }
        if (this.labelItem.classList.contains('error--text')) {
          this.labelItem.classList.remove('error--text');
        }
        if (this.messages.classList.contains('error--text')) {
          this.messages.classList.remove('error--text');
        }
      }
    }
  }
}
</script>